export { production } from './production';
export { staging } from './staging';
export { playground } from './playground';
export { sandbox } from './sandbox';

export type Environment = 'staging' | 'production' | 'sandbox' | 'playground';
